module.exports = __webpack_public_path__ + "static/10-a4893b30384519df676657f40792eafb.jpg";